import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { ShortTestimonials } from './components/ShortTestimonials';
import { PainPoints } from './components/PainPoints';
import { BrandIntro } from './components/BrandIntro';
import { TomosSlider } from './components/TomosSlider';
import { BonosSlider } from './components/BonosSlider';
import { CountdownSection } from './components/CountdownSection';
import { Pricing } from './components/Pricing';
import { ComparisonTable } from './components/ComparisonTable';
import { CrossfitPro } from './components/CrossfitPro';
import { LongTestimonials } from './components/LongTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { SalesPopup } from './components/SalesPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cf-dark text-white font-inter selection:bg-cf-gold selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SalesPopup data-id="element-2" />
      <UrgencyBar data-id="element-3" />
      <Hero data-id="element-4" />
      <StatsStrip data-id="element-5" />
      <ShortTestimonials data-id="element-6" />
      <PainPoints data-id="element-7" />
      <BrandIntro data-id="element-8" />
      <TomosSlider data-id="element-9" />
      <BonosSlider data-id="element-10" />
      <CountdownSection data-id="element-11" />
      <Pricing data-id="element-12" />
      <ComparisonTable data-id="element-13" />
      <CrossfitPro data-id="element-14" />
      <LongTestimonials data-id="element-15" />
      <Guarantee data-id="element-16" />
      <FAQ data-id="element-17" />
      <CostTable data-id="element-18" />
      <FinalCTA data-id="element-19" />
    </div>;
}